@import '~filepond/dist/filepond.min.css';
@import '~filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
@import '~filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';


.s-file-upload{
  &-wrapper{
    .filepond--file-info-main{
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}
